import { WsCallsApiError, WsCallsErrorCode } from '@gem/call/WsApi/wsCallsApi/WsCallsApiError';

import { BadRequestError } from './errors/BadRequestError';
import { ForbiddenError } from './errors/ForbiddenError';
import { ModelError } from './errors/ModelError';
import { NotFoundError } from './errors/NotFoundError';
import { UnauthorizedError } from './errors/UnauthorizedError';
import { UnhandledError } from './errors/UnhandledError';

export function buildCallsModelError(error: WsCallsApiError): ModelError {
  switch (error.code) {
    case WsCallsErrorCode.BadData:
      return new BadRequestError(error.message, error.code, error);
    case WsCallsErrorCode.Unauthorized:
      return new UnauthorizedError(error.message, error.code, error);
    case WsCallsErrorCode.Forbidden:
      return new ForbiddenError(error.message, error.code, error);
    case WsCallsErrorCode.NotFound:
      return new NotFoundError(error.message, error.code, error);
    default:
      return new UnhandledError(error.message, error.code, error);
  }
}
